module.exports = __webpack_public_path__ + "img/9.2f9cddd4.jpg";